import merge from "@tinkoff/utils/object/mergeDeep";
/**
 * Transform any series into the format expected by ChartColumn
 */
export default function columnSeriesTransformer(dataSeries) {
    // first find the unique metrics used as we need to group the data by metric
    const metrics = new Set(dataSeries.map((data) => data.metricName));
    const dataColumn = [];
    for (const metric of metrics) {
        const dataMetrics = [];
        // filter to just the metric we want to group by
        const metricSeries = dataSeries.filter((series) => series.metricName === metric);
        // push each of the data points from stat along with name which is used to create the categories
        metricSeries.forEach((series) => {
            dataMetrics.push({
                y: series.stat,
                name: series.name,
            });
        });
        // merge changed data and change series name to be the metric name
        dataColumn.push(merge(metricSeries[0], { name: metricSeries[0].metricName, data: dataMetrics }));
    }
    return dataColumn;
}
/*

The data structure we want to end up with. Each data point needs the name of the category

Highcharts.chart('container', {
    chart: {
        type: 'column'
    },

    xAxis: {
        type: 'category'
    },
        plotOptions: {
        column: {
        stacking: 'normal'
      }
    },
    series: [{
        name: 'Backend',
        data: [{
            name: 'The Verge',
            y: 1
        }, {
            name: 'Huffington',
            y: 5
        }]
    },{
        name: 'Render',
        data: [{
            name: 'The Verge',
            y: 3
        }, {
            name: 'Huffington',
            y: 2
        }]
    }]
});
 */
